export default __webpack_public_path__ + "static/media/IMG_4987-min.6aa0688f.JPG";